import WorkflowDraftContext, {
	type WorkflowDraftContextValue,
} from '@UI/Pages/Administration/DocumentGroups/DocumentGroupEdit/Providers/WorkflowDraftProvider/WorkflowDraftContext';
import * as React from 'react';

function useWorkflowDraft(): WorkflowDraftContextValue {
	const context = React.useContext(WorkflowDraftContext);

	if (context === null) {
		throw new Error('useWorkflowDraft must be used within a WorkflowDraftProvider.');
	}

	return context;
}

export default useWorkflowDraft;
